import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from '@/components/Dialog';
import { Search } from '@/components/NewHeader/Search';
import Image from 'next/image';
import { IoSearchSharp } from 'react-icons/io5';
import logoBlue from '../../../public/logo-desktop.svg';
import { useState } from 'react';

export function SearchButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <button
          id="search-villages"
          aria-label="Open village search input"
          className="cursor-pointer pr-2 flex justify-center items-center">
          <IoSearchSharp />
        </button>
      </DialogTrigger>
      <DialogContent
        className="bg-white top-0 translate-y-0 w-full max-w-full min-h-[124px] rounded-t-none"
        showCloseButton={false}>
        <DialogHeader className="justify-center items-center">
          <DialogTitle className="hidden" />
          <DialogDescription className="hidden" />
          <div className="container mx-auto flex-1 flex items-center justify-between gap-12">
            <div>
              <Image
                priority={true}
                src={logoBlue}
                className="h-10 w-auto"
                alt="Logo Villatravellers"
              />
            </div>
            <div className="flex items-center gap-4 flex-1 justify-end">
              <div className="flex-1 max-w-[50vw]">
                <Search closeDialog={() => setIsOpen(false)} />
              </div>
              <DialogClose className="p-3 uppercase text-gray-700 hover:text-gray-900 transition-colors">
                Close
              </DialogClose>
            </div>
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
